export default __webpack_public_path__ + "static/media/lbank.29931bf9.png";